import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dispatch, RootState } from '../../../../store/store';
import { useParams } from 'react-router-dom';
import InteractiveButton from '../../../../components/InteractiveButton/InteractiveButton';
import { ButtonType } from '../../../../types/button-type';
import { StatusItemsModal } from './StatusItemsModal';
import { changeFaultControlAction } from './faultControlActions';
import { EXTENDED_INTERVAL_UPDATE_DATA } from '../../../../constants/common';

type ComponentProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch>;

const FaultControl: React.FC<ComponentProps> = ({
  faultControl,
  getFaultControl,
}) => {
  const { id } = useParams();
  const [showModal, setShowModal] = useState(0);

  const onCloseModalHandler = () => {
    setShowModal(0);
  };

  const onClickBtnHandler = (idx: number) => {
    setShowModal(idx);
  };

  const updateItemHandler = useCallback(
    (setup_idx: number, setup_item_idx: number, value: boolean) => {
      const setup = faultControl[setup_idx];
      const item = setup.items[setup_item_idx];
      changeFaultControlAction(id, setup.command, item.command, value);
    },
    [faultControl, id]
  );

  useEffect(() => {
    getFaultControl(id);
    const intervalId = setInterval(() => getFaultControl(id), EXTENDED_INTERVAL_UPDATE_DATA);
    return () => clearInterval(intervalId);
  }, [id]);

  return (
    <div className="p-edit-controller-fault-control pb-4 md:pb-25">
      <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="border-b border-stroke px-7 py-4 dark:border-strokedark">
          <h3 className="font-medium text-black dark:text-white">
            Edit Fault Control
          </h3>
        </div>
        <div className="flex w-full flex-row justify-between p-7">
          <div className="flex max-md:grid max-[500px]:grid-cols-1 max-md:grid-cols-2 w-full flex-row flex-wrap justify-start gap-5.5">
            {faultControl.map((item, idx) => {
              return (
                <div key={idx}>
                  <InteractiveButton
                    className='max-md:w-full'
                    text={item.name}
                    onClick={() => onClickBtnHandler(idx + 1)}
                    type={
                      item.isActive
                        ? ButtonType.Primary
                        : ButtonType.PrimaryInverse
                    }
                  />
                  <StatusItemsModal
                    isVisible={showModal === idx + 1}
                    modalTitle={item.name}
                    onClose={onCloseModalHandler}
                    onSubmit={(item_idx, value) =>
                      updateItemHandler(idx, item_idx, value)
                    }
                    items={item.items}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapState = (state: RootState) => ({
  faultControl: state.controllers.fault_control,
});

const mapDispatch = (dispatch: Dispatch) => ({
  getFaultControl: dispatch.controllers.getControllerFaultControl,
});

export default connect(mapState, mapDispatch)(FaultControl);
